import React, { useEffect, useState } from 'react';
import { getStorySettings, login } from '../api/api';

function GenresSelect() {
  const [genres, setGenres] = useState([
    { id: 1, name: '历史正剧', checked: false },
    { id: 2, name: '武侠剧', checked: false },
    { id: 3, name: '革命战争剧', checked: false },
    { id: 4, name: '综艺', checked: false },
    { id: 5, name: '电竞', checked: false }
  ]);

  function handleGenreClick(genre) {
    genre.checked = !genre.checked;
    setGenres([...genres]);

    // 获取所有选中的类型名称
    const selectedGenreNames = genres
      .filter(s => s.checked)
      .map(s => s.name);

    // 将选中的类型名称存储到 localStorage
    localStorage.setItem('selectedGenreNames', JSON.stringify(selectedGenreNames));
  }

  return (
    <div style={{
      backgroundImage: 'url(/images/background.png)', // 使用相对于 public 目录的路径
      backgroundSize: 'cover',
      height: '100vh',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column',
      overflow: 'hidden' // 设置超出隐藏
    }}>
      <img src="/images/title.png" alt="Title" style={{
        position: 'absolute',
        top: '10px',
        left: '30px',
        width: '60px'
      }} />
      <div style={{
        position: 'absolute',
        top: '25px',
        right: '40px',
        fontWeight: 'bold',
        fontSize: '18px'
      }}>
        题材选择
      </div>

      <div 
        style={{ 
          position:'fixed',
          top:'80px',
          fontSize: '12px', 
          marginBottom: '10px', 
          fontWeight: 500 
        }}
      >
        请选择在短剧中需要出现的题材，题材可以选择多个
      </div>

    <div style={{
      width:'300px',
      display: 'flex',
      flexWrap: 'wrap',
      position: 'fixed',
      alignItems:'center',
      justifyContent:'start',
      marginLeft:'10px',
      left: '50%',
      transform: 'translateX(-50%)',
      top:'0px',
      marginTop: '120px',
    }}>
      {genres.map(genre => (
        <div 
          key={genre.id}
          style={{
            width: '80px',
            height: '40px',
            backgroundColor: genre.checked ? '#F65555' : 'white',
            border: '1px solid #ccc',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            cursor: 'pointer',
            borderRadius: '15px',
            padding: '20px',
            margin: '10px'
          }}
          onClick={() => handleGenreClick(genre)}
        >
          <span style={{ fontSize: '16px', marginTop: '5px', textAlign: 'center', width: '100%' }}>{genre.name}</span>
        </div>
      ))}
    </div>
    <button 
          onClick={() => window.location.href = '/story-summary'}
          style={{
            position: 'fixed',
            bottom: '50px',
            padding: '10px 20px',
            fontSize: '16px',
            width: '55%',
            height: '80px',
            backgroundColor: 'black',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer'
          }}>
          下一步
    </button>
    </div>
  );
}

export default GenresSelect;
